/** Запросы кабинета владельца портала для разделов «Страны и рынки» и «Продажи» (ТЗ 6.30, МР-01…МР-28) */
import type {
  Country,
  CurrencyRate,
  Funnel,
  LegalDoc,
  Partner,
  PartnerReportRow,
  PlanPrice,
  Subprocessor,
  TaxRate,
} from '@epc/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../../lib/api';

export const countriesQuery = queryOptions({
  queryKey: ['platform', 'countries'],
  queryFn: () => api<Country[]>('/platform/countries'),
});
export const taxRatesQuery = queryOptions({
  queryKey: ['platform', 'tax-rates'],
  queryFn: () => api<TaxRate[]>('/platform/tax-rates'),
});
export const currencyRatesQuery = queryOptions({
  queryKey: ['platform', 'currency-rates'],
  queryFn: () => api<CurrencyRate[]>('/platform/currency-rates'),
});
export const planPricesQuery = (planId: string) =>
  queryOptions({
    queryKey: ['platform', 'plan-prices', planId],
    queryFn: () => api<PlanPrice[]>(`/platform/plans/${planId}/prices`),
  });
export const legalQuery = queryOptions({
  queryKey: ['platform', 'legal'],
  queryFn: () => api<LegalDoc[]>('/platform/legal'),
});
export const sanctionsQuery = queryOptions({
  queryKey: ['platform', 'sanctions'],
  queryFn: () => api<Array<{ listCode: string; entries: number }>>('/platform/sanctions'),
});
export const subprocessorsQuery = queryOptions({
  queryKey: ['platform', 'subprocessors'],
  queryFn: () => api<Subprocessor[]>('/platform/subprocessors'),
});
export const partnersQuery = queryOptions({
  queryKey: ['platform', 'partners'],
  queryFn: () => api<Partner[]>('/platform/partners'),
});
export interface SpendRow {
  id: string;
  month: string;
  channel: string;
  campaign: string | null;
  countryCode: string | null;
  amount: number;
  currency: string;
}
export const spendQuery = queryOptions({
  queryKey: ['platform', 'spend'],
  queryFn: () => api<SpendRow[]>('/platform/spend'),
});
export const funnelQuery = (from: string, to: string, groupBy: Funnel['groupBy']) =>
  queryOptions({
    queryKey: ['platform', 'funnel', from, to, groupBy],
    queryFn: () => api<Funnel>('/platform/funnel', { query: { from, to, groupBy } }),
  });
export const partnerReportQuery = (from: string, to: string) =>
  queryOptions({
    queryKey: ['platform', 'partner-report', from, to],
    queryFn: () => api<PartnerReportRow[]>('/platform/partners/report', { query: { from, to } }),
  });

/** Число для таблицы: пробелы между разрядами; null — прочерк */
export function num(v: number | null | undefined, digits = 0): string {
  if (v == null) return '—';
  return v.toLocaleString('ru-RU', { maximumFractionDigits: digits, minimumFractionDigits: 0 });
}
